const searchCommonRequest = () => ({ type: 'SEARCH/COMMON_REQUEST' });
const searchCommonFailure = () => ({ type: 'SEARCH/COMMON_FAILURE' });
const searchCommonSuccess = (data) => ({ type: 'SEARCH/COMMON_SUCCESS', payload: { ...data } });
const searchCommon = (data) => ({ type: 'SEARCH/COMMON', payload: { ...data } });


export default {
  searchCommonRequest, searchCommonFailure, searchCommonSuccess, searchCommon,
};